// extracted by mini-css-extract-plugin
export var createdDate = "_jg-1";
export var divider = "_jg-2";
export var headerDivider = "_jg-3";
export var messagesCard = "_jg-0";
export var messagesContainer = "_jg-7";
export var messagesContainerWrapper = "_jg-4";
export var pointerCapturingButtonBoxes = "_jg-a";
export var showLeftPanelButton = "_jg-9";
export var showMoreButton = "_jg-c";
export var showMoreButtonContainer = "_jg-b";
export var summaryTitle = "_jg-6";
export var systemMessageCardWrapper = "_jg-d";
export var topButtons = "_jg-8";
export var withPadding = "_jg-5";